import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["additionalTracking", "currentTime", "displayInteractiveEducation", "enableQuizMe", "enableSummarize", "enableAdaptToIndustry", "handleDisplayInteractiveEducation", "interactiveEducationEnabled", "onFinish", "children"];
import { useEffect } from 'react';
import { VideoControls } from './VideoControls';
import { VideoPlayer, VideoPlayerProvider } from './VideoPlayer';
import { useCurrentVideoTime } from 'academy-common-lib/features/video/videoTimeStore';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export { useCurrentVideoTime };
export const VideoPlayerWithControls = _ref => {
  let {
      additionalTracking,
      currentTime,
      displayInteractiveEducation,
      enableQuizMe,
      enableSummarize,
      enableAdaptToIndustry,
      handleDisplayInteractiveEducation,
      interactiveEducationEnabled = false,
      onFinish,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    setCurrentVideoTime
  } = useCurrentVideoTime();
  useEffect(() => {
    setCurrentVideoTime(currentTime || 0);
  }, [currentTime, setCurrentVideoTime]);
  return /*#__PURE__*/_jsx(VideoPlayerProvider, {
    children: /*#__PURE__*/_jsxs(VideoPlayer, Object.assign({
      onFinish: onFinish,
      onTimeUpdate: time => setCurrentVideoTime(time)
    }, props, {
      children: [/*#__PURE__*/_jsx(VideoControls, {
        additionalTracking: additionalTracking,
        displayInteractiveEducation: displayInteractiveEducation,
        enableAdaptToIndustry: enableAdaptToIndustry,
        enableQuizMe: enableQuizMe,
        enableSummarize: enableSummarize,
        handleDisplayInteractiveEducation: handleDisplayInteractiveEducation,
        interactiveEducationEnabled: interactiveEducationEnabled,
        onFinish: onFinish
      }), children]
    }))
  });
};
export default VideoPlayerWithControls;